const translations = {
    placeholder: 'Search for an address'
};

export default translations;
